import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=a22bbd86&"
import script from "./Configurator.vue?vue&type=script&lang=js&"
export * from "./Configurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a22bbd86')) {
      api.createRecord('a22bbd86', component.options)
    } else {
      api.reload('a22bbd86', component.options)
    }
    module.hot.accept("./Configurator.vue?vue&type=template&id=a22bbd86&", function () {
      api.rerender('a22bbd86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/Configurator.vue"
export default component.exports